import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint) => apiCall("delete", endpoint);

export const getTransactionListApi = async (params) => {
  try {
    return await get("transaction", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getPaymentApi = async (params) => {
  try {
    return await get("get_payment_type", params);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const getTransactionApi = async (id) => {
  try {
    return await get(`transaction/view/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const updateStageApi = async (id, bodyData) => {
  try {
    return await put(`transaction/stage_update/${id}`, bodyData);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const deleteTransApi = async (id) => {
  try {
    return await del(`transaction/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};
export const deleteHistoryApi = async (id) => {
  try {
    return await del(`payment/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const submitTransactionAPI = async (body) => {
  try {
    return await post("transaction", body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    return await put(`transaction/add_attachment/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateTransactionAPI = async (id, body) => {
  try {
    return await put(`transaction/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getTransactionEditApi = async (id) => {
  try {
    return await get(`transaction/edit/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const getPODetailsApi = async (id) => {
  try {
    return await get(`get_purchase_order_details/${id}`);
  } catch (err) {
    console.error("Error fetching category:", err);
  }
};

export const downloadExcelApi = async (apivalue) => {
  try {
    return await get(apivalue);
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  }
};

export const uploadExcelApi = async (apivalue, base64String) => {
  try {
    const data = {
      upload_file: base64String,
    };
    return await post(apivalue, data);
  } catch (err) {
    console.error("Error fetching options:", err);
    return err.response;
  }
};

export const downloadTemplateExcelApi = async (mater_type) => {
  try {
    return await get("template_download", { type: mater_type });
  } catch (err) {
    console.error("Error fetching options:", err);
    return err.response;
  }
};

export const savePaymentAttachApi = async (id, body) => {
  try {
    return await put(`transaction/add_attachment/${id}`, body);
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getEditHistoryApi = async (id) => {
  try {
    return await get(`transaction/history/${id}`);
  } catch (err) {
    console.error("Error fetching edit history:", err);
  }
};

export const extractBillApi = async (body) => {
  try {
    return await post("vendor/bill_extract", body);
  } catch (err) {
    console.error("Error extracting bill:", err);
    return err.response;
  }
};
